import { useEffect, useRef, useState } from 'react';

const AREAS = [
  'Gulfport, MS',
  'Biloxi, MS',
  'Ocean Springs, MS',
  'Long Beach, MS',
  'Diamondhead, MS',
  'Bay St. Louis, MS',
  'Waveland, MS',
  "D'Iberville, MS",
  'Saucier, MS',
];

export default function ServiceAreas() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="areas" ref={ref} className="py-24 md:py-32 bg-obsidian relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/25 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/8 to-transparent"></div>

      {/* Background image overlay */}
      <div className="absolute inset-0 opacity-5">
        <img
          src="https://public.readdy.ai/ai/img_res/e8df1ef229f5d6a0e153eb98d16f063f.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row gap-14 items-start">

          {/* Left — content */}
          <div className={`flex-1 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-gold"></span>
              <span className="text-[11px] font-bold tracking-super uppercase text-gold">Service Areas</span>
            </div>
            <h2 className="font-condensed font-bold text-5xl md:text-6xl text-white uppercase leading-none mb-3">
              Serving Homeowners<br />
              <span className="font-serif font-normal italic text-gold/80 text-4xl md:text-5xl normal-case leading-tight">
                &amp; Businesses Locally
              </span>
            </h2>
            <div className="w-10 h-px bg-gold/40 my-6"></div>
            <p className="text-white/50 text-base leading-relaxed font-light mb-8 max-w-lg">
              We provide roofing services across the Mississippi Gulf Coast. Our team understands local weather patterns — from hurricane-season storms to coastal humidity — and builds roofing systems specifically engineered to withstand them.
            </p>

            {/* Area pills grid */}
            <div className="flex flex-wrap gap-2.5 mb-10">
              {AREAS.map(area => (
                <div key={area}
                  className="flex items-center gap-2 border border-white/12 text-white/60 text-[11px] font-medium tracking-widest uppercase px-4 py-2.5 rounded-full hover:border-gold/40 hover:text-gold transition-all cursor-default">
                  <i className="ri-map-pin-2-fill text-gold text-[10px]"></i>
                  {area}
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 text-sm text-white/35 border-t border-white/8 pt-6">
              <div className="flex items-center gap-2">
                <i className="ri-phone-fill text-gold text-xs"></i>
                <a href="tel:2285473887" className="hover:text-gold transition-colors cursor-pointer">(228) 547-3887</a>
              </div>
              <span className="hidden sm:block text-white/15">|</span>
              <div className="flex items-center gap-2">
                <i className="ri-mail-fill text-gold text-xs"></i>
                <a href="mailto:alldoneroofing1@gmail.com" className="hover:text-gold transition-colors cursor-pointer">alldoneroofing1@gmail.com</a>
              </div>
            </div>
          </div>

          {/* Right — map */}
          <div className={`w-full lg:w-[480px] shrink-0 transition-all duration-700 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
            <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '400px' }}>
              <iframe
                src="https://maps.google.com/maps?q=Gulfport%2C+MS&t=m&z=10&output=embed&iwloc=near"
                title="All Done Roofing Service Area - Gulfport, MS"
                className="w-full h-full"
                loading="lazy"
                style={{ border: 0 }}
              ></iframe>
            </div>
            <p className="text-white/25 text-[11px] tracking-widest uppercase mt-3 text-center">Mississippi Gulf Coast Coverage Area</p>
          </div>
        </div>
      </div>
    </section>
  );
}
